import {
    BookOutlined,
    CommentOutlined,
    ExperimentOutlined,
    FileTextOutlined,
    VideoCameraOutlined,
} from "@ant-design/icons";
import { Avatar, Collapse } from "antd";

const { Panel } = Collapse;

const CourseModules = ({ modules = [], about = "", trainers }) => {
    return (
        <div className="flex flex-col lg:flex-row gap-6 p-6 bg-gray-50">
            {/* Left Section */}
            <div className="flex-1">
                <h2 className="text-lg font-semibold mb-4">
                    There are {modules.length} modules in this course
                </h2>
                <p className="text-gray-600 mb-4">{about}</p>
                {modules.length > 0 ? (
                    <Collapse
                        accordion
                        className="bg-white border border-gray-300 rounded-lg shadow-md"
                        defaultActiveKey={["0"]}
                    >
                        {modules.map((module, index) => (
                            <Panel
                                header={
                                    <div className="flex justify-between items-center">
                                        <span>
                                            <b>{module.title}</b>
                                        </span>
                                        <span className="text-gray-500">
                                            Module {module.name} • {module.topics.reduce((a, c) => a + c.hours, 0)} hours to complete
                                        </span>
                                    </div>
                                }
                                key={index} // Use a unique key for each module
                            >
                                {module.description && (
                                    <p className="text-gray-600 mb-4 ">{module.description}</p>
                                )}
                                <div className="mb-4">
                                    {module.topics.length > 0 && <h4 className="font-semibold text-gray-700 mb-6">
                                        What's included
                                    </h4>}
                                    {module.topics.map(topic =>
                                        <ul className="flex flex-wrap gap-x-4 gap-y-2 text-gray-600 border-b border-b-gray-200 pb-3">
                                            <li className="flex-0 w-full font-medium text-lg" >{topic.name}</li>
                                            <li className="flex items-center gap-2">
                                                <VideoCameraOutlined className="text-blue-500" />
                                                {topic.hours} Hr videos
                                            </li>

                                            <li className="flex items-center gap-2">
                                                <BookOutlined className="text-blue-500" />
                                                Related Notes
                                            </li>

                                            <li className="flex items-center gap-2">
                                                <FileTextOutlined className="text-blue-500" />
                                                Assignments
                                            </li>
                                            <li className="flex items-center gap-2">
                                                <CommentOutlined className="text-blue-500" />
                                                Includes Doubt Session
                                            </li>
                                            {/* {module?.details?.ungradedLabs > 0 && (
                                                <li className="flex items-center gap-2">
                                                    <ExperimentOutlined className="text-blue-500" />
                                                    {module?.details?.ungradedLabs} ungraded labs
                                                </li>
                                            )} */}
                                        </ul>
                                    )}
                                </div>

                            </Panel>
                        ))}
                    </Collapse>
                ) : (
                    <p className="text-gray-600">No modules available for this course.</p>
                )}
            </div>

            {/* Right Section */}
            <div className="w-full lg:w-1/3">
                <div className="bg-white p-4 rounded-lg shadow-md border border-gray-300">
                    <h3 className="font-semibold text-gray-700">Instructors</h3>
                 
                    {trainers.map((trainerData, index) => (
    <div key={index} className="flex items-center gap-2 mb-4">
       { trainerData.user.imgUrl === ""?<Avatar style={{ backgroundColor: "#a76200", verticalAlign: 'middle' }} size="large" gap={4}>
            {trainerData.name.split("")[0]}
        </Avatar> :  <div className="w-10 h-10 rounded-full bg-gray-200"><img
                                    src={trainerData?.imgUrl}
                                    alt={trainerData.name}
                                    className="w-10 h-10 object-cover mx-auto rounded-full mb-4"
                                /></div>}
        <div>
            <p className="font-semibold text-gray-700">{trainerData.name}</p> {/* Dynamically render title */}
            <p className="text-gray-600">{trainerData.courses} Courses • {trainerData.learners} learners</p> {/* Dynamically render course count and learner count */}
        </div>
    </div>
))}
                    <h3 className="font-semibold text-gray-700">Offered by</h3>
                    <div className="flex items-center gap-2 mt-2">
                        <div className="w-8 h-8 rounded-full bg-gray-200"> <img src="https://pronttera-resource.s3.ap-south-1.amazonaws.com/logos/amber+dark+logo.png" alt="" srcset="" /></div>
                        <p className="text-gray-600 font-semibold">Pronttera</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CourseModules;
